/**
 * 格式化地址
 * @param province
 * @param city
 * @param address
 * @param area
 * @returns {string}
 */
export default function formatAddress(province, city, address, area) {
  if (isEmptyObject(province)) {
    return ''
  }
  if (isEmptyList(area)) {
    return ''
  }
  let string = ''
  area.forEach((p, index) => {
    if (p.id === province) {
      string = string + p.name
      p.children.forEach(c => {
        if (c.id === city) {
          string = string + '-' + c.name
          c.children.forEach(a => {
            if (a.id === address) {
              string = string + '-' + a.name
              return
            }
          })
        }
      })
    }
  })
  return string
}

/**
 * 空对象校验
 * @param object
 * @returns {boolean}
 */
export function isEmptyObject(object) {
  return !object || JSON.stringify(object) === '{}'
}

/**
 * 空list校验
 * @param list
 * @returns {boolean}
 */
export function isEmptyList(list) {
  return list == null || list === undefined || list.length <= 0
}

// 表单json对象转URLSearchParams，以键值对的形式提交表单
export function jsonToURLSearchParams(json) {
  let searchParams = new URLSearchParams()
  for (let k in json) {
    searchParams.append(k, json[k])
  }
  return searchParams
}

/**
 * 判断是否是json
 * @param obj
 * @returns {boolean}
 */
export function isJson(obj) {
  return (typeof obj == 'object') && Object.prototype.toString.call(obj).toLowerCase() == '[object object]' && !obj.length
}

/**
 * get 请求参数拼接
 * @param json
 * @returns {string|*}
 */
export function appendParam(json) {
  return appendParam2(json, '', '', 0)
}

function appendParam2(json, base, s, i) {
  for (let k in json) {
    if (isJson(json[k])) {
      s = appendParam2(json[k], base + k + '.', s, i)
    } else if (i == 0) {
      s = '?' + k + '=' + json[k]
    } else {
      s = s + '&' + k + '=' + json[k]
    }

    i++
  }
  return s
}



// WEBPACK FOOTER //
// ./src/module/memberCenter/common/methods.js